import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

import Amplify, { Auth } from '@aws-amplify/auth';
import AwsConfig from '../aws-exports';

import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular';

import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { PrimengModule } from './modules/shared/primeng.module';

import { CookieService } from 'ngx-cookie-service';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { providePrimeNG } from 'primeng/config';

import { environment } from '../environments/environment';

const DoublesTeamPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{orange.50}',
      100: '{orange.100}',
      200: '{orange.200}',
      300: '{orange.300}',
      400: '{orange.400}',
      500: '#f29331',
      600: '{orange.600}',
      700: '{orange.700}',
      800: '{orange.800}',
      900: '{orange.900}',
      950: '{orange.950}',
    },
  },
});

Amplify.configure(AwsConfig);
Auth.configure(AwsConfig);

Sentry.init(
  {
    dsn: environment.production ? environment.sentryDsn : '', //run only on prod mode
    //dsn: environment.sentryDsn, //run only on local mode

    // Set your release version, such as "getsentry@1.0.0"
    release: `queue@${environment.appVersion}`,
    // Set your dist version, such as "1"
    dist: '1',
  },
  // Forward the init method from @sentry/angular
  SentryAngular.init
);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    PrimengModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    providePrimeNG({
      theme: {
        preset: DoublesTeamPreset,
        options: {
          darkModeSelector: 'none',
          cssLayer: false,
        },
      },
    }),
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    CookieService,
    {
      provide: ErrorHandler,
      // Attach the Sentry ErrorHandler
      useValue: SentryAngular.createErrorHandler(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
